<template>
  <div class="min-h-screen w-full bg-white bg-kekkle-pattern bg-repeat">
    <div
      class="flex min-h-screen w-full flex-col items-center justify-center bg-white bg-opacity-[95%] px-4 py-8 dark:bg-kekkle-dark-dark dark:bg-opacity-[90%]"
    >
      <!-- Language Selector -->
      <div class="absolute right-4 top-4 w-auto">
        <language-selector />
      </div>

      <img
        alt="Kekkle Logo"
        class="mb-4 w-24"
        src="/img/logo/logo-color-trans.svg"
      />
      <img
        alt="Kekkle wordmark"
        class="mb-4 w-36"
        :src="
          darkModeEnabled
            ? '/img/wordmark/wordmark-white.svg'
            : '/img/wordmark/wordmark-black.svg'
        "
      />

      <router-view />
    </div>
  </div>
</template>

<script>
import { useDarkModeStore } from "@/stores/modules/darkmode/darkmode";
import LanguageSelector from "@/components/ui/LanguageSelector.vue";

export default {
  name: "AuthenticationLayout",
  components: {
    LanguageSelector,
  },
  setup() {
    const darkModeStore = useDarkModeStore();
    return {
      darkModeStore,
    };
  },
  computed: {
    darkModeEnabled() {
      return this.darkModeStore.darkModeEnabled;
    },
  },
};
</script>
